import { getWindowOpen } from '../../../utils/window';

export const navigateToUrl = (url = '', isNewWindow = false) => {
  if (url !== '') {
    const open = getWindowOpen();
    open(url, isNewWindow ? '_blank' : '_self');
  }
};
